<!-- =========================================================================================
  File Name: ECommerceShop.vue
  Description: eCommerce Shop Page
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
    Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->

<template>
  <div v-if="category && category.analysis && category.analysis.cyclopedia" id="main-container">
    <div class="vx-row mt-5 mb-2">
      <div class="vx-col w-full mb-1">
        <h5>Book/title: <b>{{ cyclopediaHelpers.getPreferredName(category.analysis.cyclopedia) }} (ID: {{ category.analysis.cyclopedia.id }})</b></h5>
        <h5>Analysis: <b>{{ analysisHelpers.getPreferredName(category.analysis) }} (ID: {{ category.analysis.id }})</b></h5>
      </div>
    </div>
    <div class="vx-row mt-5 mb-2">
      <div class="vx-col w-full mb-1">
        <span class="h1 float-left">{{ categoryHelpers.getPreferredName(category) }} (ID: {{ category.id }})</span>
        <vs-button class="ml-auto" color="danger" icon="delete_outline" type="gradient" @click="confirmDeleteCategory">Delete Category</vs-button>
      </div>
    </div>


    <div class="vx-row mt-1">
      <div class="vx-col md:w-1/2 w-full mb-1">
        <CategoryNameAndDescCard :category="category"
                                 v-on:categoryUpdated="updateCategory"></CategoryNameAndDescCard>
      </div>
      <div class="vx-col md:w-1/2 w-full mb-1">
        <ProductsSelectionCard :category="category"
                               :products="products"
                               v-on:categoryUpdated="updateCategory"
        ></ProductsSelectionCard>
      </div>
    </div>

<!--    <vs-prompt-->
<!--      buttons-hidden-->
<!--      :title="analysisHelpers.getPreferredName(category.analysis)"-->
<!--      :active.sync="showCategoryLocalizationsDialogFlag">-->
<!--      <div class="modal-lg">-->
<!--        <ProductsSelectionCard :category="category"-->
<!--                               :products="products"-->
<!--                                     v-on:categoryUpdated="updateCategory"-->
<!--        ></ProductsSelectionCard>-->
<!--      </div>-->
<!--    </vs-prompt>-->
<!--    <div class="mt-5" v-html="jsonHtml.toHtml(cyclopedia)"></div>-->
  </div>
</template>

<script>
  import api from '@/http/api';
  import jsonHtml from '@/misc/jsonHtmlPrinter'
  import helpers from '@/models/helpers'
  import CategoryNameAndDescCard from './CategoryNameAndDescCard';
  import ProductsSelectionCard from './ProductsSelectionCard';

  export default {
    components: {
      CategoryNameAndDescCard,
      ProductsSelectionCard,
    },
    mounted() {
      this.fetchAll();
    },
    data() {
      return {
        jsonHtml: jsonHtml,
        isLoading: false,
        showCategoryLocalizationsDialogFlag: false,
        cyclopediaHelpers: helpers.cyclopedia,
        analysisHelpers: helpers.cyclopediaAnalysis,
        categoryHelpers: helpers.cyclopediaAnalysisCategory,
        productHelpers: helpers.product,
        category: null,
        products: [],
      }
    },
    computed: {
      categoryId() {
        return this.$route.query.id || null;
      },
    },
    watch: {
      isLoading(oldVal, newVal) {
        if (!newVal) {
          this.$vs.loading();
        } else {
          this.$vs.loading.close();
        }
      }
    },
    methods: {
      async fetchAll() {
        this.isLoading = true;
        await this.fetchCategory();
        // wait until the category is fetched to get the products
        await this.fetchProducts();

        this.isLoading = false;
      },
      async fetchCategory() {
        this.category = await api.fetchLeanAnalysisCategory(this.categoryId);
      },
      async fetchProducts() {
        let productPromises = [];
        for (let i=0;i<this.category.analysis.cyclopedia.companies.length;i++) {
          let company = this.category.analysis.cyclopedia.companies[i];
          productPromises.push(api.fetchProductsForCompany(company.company_id));
        }

        let completedProductArrays = await Promise.all(productPromises);
        let products = [];
        completedProductArrays.forEach((it) => {
          products = products.concat(it);
        });
        products.forEach((it) => {
          it._name = `${it.product_id} - ${this.productHelpers.getPreferredName(it)}`;
        });

        this.products = products;
      },
      async updateCategory(category) {
        this.category = category;
        this.showCategoryLocalizationsDialogFlag = false;
      },
      confirmDeleteCategory() {
        this.$vs.dialog({
          type: 'confirm',
          color: 'danger',
          acceptText: 'DELETE',
          title: `DELETE ${this.categoryHelpers.getPreferredName(this.category)}`,
          text: `Are you sure you want to delete this category?`,
          accept: () => {
            this.deleteCategory(this.category);
          }
        })
      },
      async deleteCategory() {
        const success = api.deleteAnalysisCategory(this.category);
        if (!success) {
          this.showNotification(false, 'error deleting analysis');
          return;
        }

        this.showNotification(true, `Category "${this.categoryHelpers.getPreferredName(this.category)}" Deleted`);
        this.$router.back();
      },
      showNotification(success, message) {
        this.$vs.notify({
          title: success ? 'Success' : 'Error',
          text: message ? message : '',
          color: success ? 'success' : 'danger',
          icon: success ? 'check_circle_outline' : 'error'
        });
      },
    },
  }

</script>


<style lang="scss">

</style>

